import React, { Component } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import { Link } from 'react-router-dom';

import { withAppContext } from '../../contexts/app';

// Using posed in order to easily animate expand/collapse of the condition description
const PosedConditionContent = posed.div({
  expanded: { height: 'auto' },
  collapsed: { height: 0 }
});

class ConditionsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedConditionId: null
    };
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({ expandedConditionId: null });
  }

  render() {
    return (
      <div id={this.props.id} className="conditions-list">
        <div className="container">

          { Object.entries(this.props.conditions).length === 0 &&
            <div className="conditions-list__no-search-results">
              No conditions found matching your search were found.
            </div>
          }

          { Object.entries(this.props.conditions).map(([letter, conditions]) => (
            <div
              key={letter}
              id={`letter-group-${letter.toLowerCase()}`}
              className="conditions-list__letter-group"
            >
              <div className="conditions-list__letter-group__letter">{ letter }</div>
              <div className="conditions-list__letter-group__icon" />

              { this.props.conditions.length }

              <div className="conditions-list__letter-group__list">
                { conditions.map((condition) => {
                  const linkPath = `${this.props.app.healthPages.basePath}${this.props.app.healthPages.conditionPagesPath}/${condition.id}`;

                  return (
                    <div key={condition.id} className="conditions-list__condition-entry">
                      <Link to={linkPath} className="conditions-list__condition-row">
                        <div className="conditions-list__condition-row__title">
                          { condition.title }
                        </div>

                        <div className="conditions-list__condition-row__button">
                          <button>Learn more</button>
                        </div>

                        <div
                          className={`conditions-list__condition-row__expando ${!condition.description ? 'collapsed' : ''} ${this.state.expandedConditionId === condition.id ? 'rotated' : ''}`}
                          onClick={this.handleExpandoClick.bind(this, condition.id)}
                        >
                          <button><i className="icon icon--bottom"/></button>
                        </div>
                      </Link>

                      { condition.description &&
                        <PosedConditionContent
                          className="conditions-list__condition-info"
                          pose={this.state.expandedConditionId === condition.id ? 'expanded' : 'collapsed'}
                        >
                          <Link to={linkPath}>
                            <div className="conditions-list__condition-info__content">
                              <div className="conditions-list__condition-info__description">
                                { condition.description }
                              </div>

                              { condition.symptoms &&
                                <div className="conditions-list__condition-info__symptoms">
                                  <ul>
                                    { condition.symptoms.map((symptom, index) => (
                                      <li key={index}>{ symptom }</li>
                                    ))}
                                  </ul>
                                </div>
                              }
                            </div>
                          </Link>
                        </PosedConditionContent>
                      }
                    </div>
                  );
                }) }
              </div>
            </div>
          ))}

        </div>
      </div>
    );
  }

  handleExpandoClick(conditionId, event) {
    event.preventDefault();

    // Only one condition can be expanded at a given time. Works as a typical accordion
    this.setState({ expandedConditionId: this.state.expandedConditionId === conditionId ? null : conditionId });
  }
}

ConditionsList.defaultProps = {
  id: ''
};

ConditionsList.propTypes = {
  app: PropTypes.object.isRequired,
  id: PropTypes.string,
  conditions: PropTypes.object.isRequired
};

export default withAppContext(ConditionsList);
